/**
 * Created by robert.lavoie on 6/15/17.
 */


import { Component, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';

// Models
import { Site, MenuLink } from 'careerpages-base/models';

/**
 *
 * @class
 * CustomerSiteFooterComponent
 *
 *
 * @description
 * The footer background is styled according to the theme color
 * The footer contains optional contact information and social media icons which link
 * to a customers social media links
 *
 */
@Component({
  templateUrl: './customer-site-footer.component.html',
  selector: 'customer-site-footer',
  styleUrls: ['./customer-site-footer.component.scss']
})
export class CustomerSiteFooterComponent implements OnChanges {

    // The current customer site we are within
  @Input() site: Site;

    // Read only is set to true when we are previewing the site
    // when we are in editing the site mode its set to false
  @Input() isReadOnly: boolean = true;

  @Output() clickEvent: EventEmitter<string> = new EventEmitter();

  footerLinks: MenuLink[];

  ngOnChanges(changes: SimpleChanges) {
    if (changes.site) {
      const site = changes.site.currentValue;
      this.footerLinks = (site.menu && site.menu.links) ? site.menu.links.filter(item => item.linkInFooter) : [];
    }
  }

}
